import { CardContent, Grid, Typography } from "@material-ui/core";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import React from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";

interface devisionCardFinancial {
    id: number | undefined;
    logo: string | undefined;
    borderRadius?: string | undefined;
    title?: string | undefined;
}

const DevisionCardFinancial = ({
    id,
    logo,
    borderRadius,
    title
}: devisionCardFinancial) => {
    return (
        <>
            <Card
                className="centerVertical"
                variant="outlined"
                sx={{
                    boxShadow: 1,
                    border: 1,
                    borderColor: "#DAE0E4",
                    borderRadius: borderRadius ? borderRadius : "6px !important",
                }}
                style={{
                    height: "150px",
                    width: "90%",
                    backgroundColor: "#F6F8F9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                }}
            >
                <CardContent style={{ alignSelf: "center", paddingTop: "2em" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {logo === "" || logo === null || logo === undefined ? (
                            <>
                                <StorefrontIcon
                                    style={{
                                        width: "75px",
                                        height: "75px",
                                        color: "#9a9e9e",
                                        padding: "15px",
                                    }}
                                // className="suppliersCardImg"
                                />
                            </>
                        ) : (
                            <>
                                <img
                                    style={{ height: '55px', marginRight: '4vh', marginLeft: '4vh', marginBottom: '15px' }}
                                    src={`data:image/png;base64,${logo}`}
                                    alt=""
                                />
                            </>
                        )}

                    </Box>
                    <span style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', display: 'block' }}>{title}</span>
                </CardContent>
            </Card>
        </>
    );
};

export default DevisionCardFinancial;
